
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductSequenceGrid extends Serenity.EntityGrid<ProductSequenceRow, any> {
        protected getColumnsKey() { return 'OMS.ProductSequence'; }
        protected getDialogType() { return ProductSequenceDialog; }
        protected getIdProperty() { return ProductSequenceRow.idProperty; }
        protected getInsertPermission() { return ProductSequenceRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductSequenceRow.localTextPrefix; }
        protected getService() { return ProductSequenceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}